import sessionStorage from '../utils/storage/session_storage';
import localStorage from '../utils/storage/local_storage';
import { BBModel } from '../bb_model';
import { halClient } from '../hal';
import sharedHeader from '../shared_header';
import cookies from 'axios/lib/helpers/cookies';

function storeUser(user) {

    if (!user.company_id) return;

    let users = JSON.parse(localStorage.getItem('users'));

    if (!users) users = {};

    users[user.company_id] = user.$toStore();

    localStorage.setItem('users', JSON.stringify(users));

    localStorage.setItem('classicCompanyId', user.company_id);
    sessionStorage.setItem('companyId', user.company_id);

    localStorage.setItem('loggedIn', true);
}

function restoreUser(companyId = sessionStorage.getItem('companyId')) {

    const users = JSON.parse(localStorage.getItem('users'));

    if (!users) {
        return null;
    }

    if (!companyId) {
        return null; // Client should use first available user from session and fetch base_login
    }

    const user = users[companyId];

    if (!user) {
        return null;
    }

    return new BBModel.Admin.User(halClient.createResource(user));
}

function clearAll() {
    sessionStorage.removeItem('companyId');

    localStorage.removeItem('classicCompanyId');
    localStorage.removeItem('users');
    localStorage.removeItem('sso_token');
    localStorage.removeItem('sso_company_id');
    localStorage.removeItem('api_key');

    cookies.remove('Auth-Token');
    sharedHeader.del('auth_token');
}

export default {
    storeUser,
    restoreUser,
    clearAll
};
